import { render, staticRenderFns } from "./ChatGroupManage.vue?vue&type=template&id=3e1c21fc&scoped=true"
import script from "./ChatGroupManage.vue?vue&type=script&lang=js"
export * from "./ChatGroupManage.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupManage.vue?vue&type=style&index=0&id=3e1c21fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1c21fc",
  null
  
)

export default component.exports